export default "__VITE_ASSET__DVko79Jl__"